<template>
  <div>
    <div class="market-box">
      <div class="all-box">
        <div class="box1">
          <BoxContent1 />
        </div>
        <div class="box2">1</div>
        <div class="box3">1</div>
        <div class="box4"><BoxContent4 /></div>
      </div>
    </div>
    <VFooter />
  </div>
</template>

<script>
import VFooter from "@/components/footer/VFooter";
import BoxContent1 from "./components/BoxContent1";
import BoxContent4 from "./components/BoxContent4";
export default {
  components: {
    VFooter,
    BoxContent1,
    BoxContent4,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.market-box {
  position: relative;
  background: #f5f6f7;
  padding: 25px 20px 120px 20px;
  .all-box {
    gap: 12px;
    display: flex;
    .box1 {
      width: 364px;
    }
    .box2 {
      flex: 1;
      background: #fff;
    }
    .box3 {
      width: 302px;
      background: #fff;
    }
    .box4 {
      width: 302px;
      background: #fff;
    }
  }
}
</style>
